var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-gallery" }, [
    _c(
      "div",
      { staticClass: "product-gallery__featured" },
      [
        _c(
          "button",
          {
            staticClass: "product-gallery__zoom",
            attrs: { type: "button" },
            on: { click: _vm.handleGalleryZoomBtnClick }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M15 18c-2 0-3.8-.6-5.2-1.7-1 1.3-2.1 2.8-3.5 4.6-2.2 2.8-3.4 1.9-3.4 1.9s-.6-.3-1.1-.7c-.4-.4-.7-1-.7-1S.2 19.9 3 17.8c1.8-1.4 3.3-2.5 4.6-3.5C6.6 12.8 6 11 6 9c0-5 4-9 9-9s9 4 9 9-4 9-9 9zm0-16c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm1 11h-2v-3h-3V8h3V5h2v3h3v2h-3v3z"
                  }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("PhotoSwipe", {
          attrs: {
            "is-open": _vm.isPhotoSwipeOpen,
            items: _vm.productImages,
            options: _vm.photoSwipeOptions
          },
          on: {
            close: _vm.hidePhotoSwipe,
            afterChange: _vm.handlePhotoSwipeChange
          }
        }),
        _vm._v(" "),
        _c(
          "swiper",
          {
            ref: "featuredSwipper",
            staticClass: "swiper",
            attrs: { options: _vm.swipperOptions },
            on: { slideChange: _vm.handleSliderCarouselChange }
          },
          [
            _vm._l(_vm.productImages, function(image, index) {
              return _c("swiper-slide", { key: index }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "product-image product-image--location--gallery"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "product-image__body",
                        on: { click: _vm.handleGalleryZoomBtnClick }
                      },
                      [
                        _c("img", {
                          staticClass: "product-image__img",
                          attrs: {
                            src: image.src,
                            alt: _vm.product.name + "_" + index
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-pagination",
              attrs: { slot: "pagination" },
              slot: "pagination"
            })
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "product-gallery__carousel" },
      [
        _c(
          "swiper",
          {
            ref: "carouselSwipper",
            staticClass: "swiper",
            attrs: { options: _vm.swipperOptionsCarusel },
            on: { "click-slide": _vm.handleClickCaruselSlide }
          },
          [
            _vm._l(_vm.productImages, function(image, index) {
              return _c("swiper-slide", { key: index }, [
                _c(
                  "a",
                  {
                    class: [
                      {
                        "product-gallery__carousel-item": true,
                        "product-image": true,
                        "product-gallery__carousel-item--active":
                          index == _vm.swipperCaruselActiveIndex
                      }
                    ]
                  },
                  [
                    _c("span", { staticClass: "product-image__body" }, [
                      _c("img", {
                        staticClass:
                          "product-image__img product-gallery__carousel-image",
                        attrs: { src: image.src, alt: "" }
                      })
                    ])
                  ]
                )
              ])
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-pagination-2",
              attrs: { slot: "pagination" },
              slot: "pagination"
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }